<script lang="ts">// prettier-ignore
const { as = 'p', variant, isBalanced, children, class: className = '', ...rest } = $props();
const mappedVariant = {
    h1: '1000',
    h2: '900',
    h3: '800',
    h4: '700',
    h5: '700',
    h6: '700',
    p: '100-r',
    span: '100-r',
};
const mappedBalance = {
    '1000': true,
    '900': true,
    '800': true,
    '700': true,
    '600': true,
    '200': false,
    '100': false,
    '100-r': false,
    '50': false,
    '50-r': false,
};
export {};
</script>

<svelte:element
  this={as}
  {...rest}
  class="Text Text-variant--{variant ?? mappedVariant[as]} {className}"
  class:balanced={isBalanced ?? mappedBalance[variant ?? mappedVariant[as]]}
>
  {@render children?.()}
</svelte:element>

<style>@layer design-system-components.pwds {
  .Text-variant--1000 {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-1000-font-size);
    --font-weight: var(--text-variant-1000-font-weight);
    --letter-spacing: var(--text-variant-1000-letter-spacing);
    --line-height: var(--text-variant-1000-line-height);
    --max-width: var(--text-variant-1000-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Text-variant--1000 :global(sup) {
    font-variant-numeric: tabular-nums;
    vertical-align: super;
    top: 0;
    font-weight: var(--text-variant-1000-superscript-font-weight);
    font-size: var(--text-variant-1000-superscript-font-size);
  }
  .Text-variant--900 {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-900-font-size);
    --font-weight: var(--text-variant-900-font-weight);
    --letter-spacing: var(--text-variant-900-letter-spacing);
    --line-height: var(--text-variant-900-line-height);
    --max-width: var(--text-variant-900-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Text-variant--900 :global(sup) {
    font-variant-numeric: tabular-nums;
    vertical-align: super;
    top: 0;
    font-weight: var(--text-variant-900-superscript-font-weight);
    font-size: var(--text-variant-900-superscript-font-size);
  }
  .Text-variant--800 {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-800-font-size);
    --font-weight: var(--text-variant-800-font-weight);
    --letter-spacing: var(--text-variant-800-letter-spacing);
    --line-height: var(--text-variant-800-line-height);
    --max-width: var(--text-variant-800-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Text-variant--800 :global(sup) {
    font-variant-numeric: tabular-nums;
    vertical-align: super;
    top: 0;
    font-weight: var(--text-variant-800-superscript-font-weight);
    font-size: var(--text-variant-800-superscript-font-size);
  }
  .Text-variant--700 {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-700-font-size);
    --font-weight: var(--text-variant-700-font-weight);
    --letter-spacing: var(--text-variant-700-letter-spacing);
    --line-height: var(--text-variant-700-line-height);
    --max-width: var(--text-variant-700-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Text-variant--700 :global(sup) {
    font-variant-numeric: tabular-nums;
    vertical-align: super;
    top: 0;
    font-weight: var(--text-variant-700-superscript-font-weight);
    font-size: var(--text-variant-700-superscript-font-size);
  }
  .Text-variant--600 {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-600-font-size);
    --font-weight: var(--text-variant-600-font-weight);
    --letter-spacing: var(--text-variant-600-letter-spacing);
    --line-height: var(--text-variant-600-line-height);
    --max-width: var(--text-variant-600-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Text-variant--600 :global(sup) {
    font-variant-numeric: tabular-nums;
    vertical-align: super;
    top: 0;
    font-weight: var(--text-variant-600-superscript-font-weight);
    font-size: var(--text-variant-600-superscript-font-size);
  }
  .Text-variant--200 {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-200-font-size);
    --font-weight: var(--text-variant-200-font-weight);
    --letter-spacing: var(--text-variant-200-letter-spacing);
    --line-height: var(--text-variant-200-line-height);
    --max-width: var(--text-variant-200-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Text-variant--200 :global(sup) {
    font-variant-numeric: tabular-nums;
    vertical-align: super;
    top: 0;
    font-weight: var(--text-variant-200-superscript-font-weight);
    font-size: var(--text-variant-200-superscript-font-size);
  }
  .Text-variant--100 {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-100-font-size);
    --font-weight: var(--text-variant-100-font-weight);
    --letter-spacing: var(--text-variant-100-letter-spacing);
    --line-height: var(--text-variant-100-line-height);
    --max-width: var(--text-variant-100-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Text-variant--100 :global(sup) {
    font-variant-numeric: tabular-nums;
    vertical-align: super;
    top: 0;
    font-weight: var(--text-variant-100-superscript-font-weight);
    font-size: var(--text-variant-100-superscript-font-size);
  }
  .Text-variant--100-r {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-100-r-font-size);
    --font-weight: var(--text-variant-100-r-font-weight);
    --letter-spacing: var(--text-variant-100-r-letter-spacing);
    --line-height: var(--text-variant-100-r-line-height);
    --max-width: var(--text-variant-100-r-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Text-variant--100-r :global(sup) {
    font-variant-numeric: tabular-nums;
    vertical-align: super;
    top: 0;
    font-weight: var(--text-variant-100-r-superscript-font-weight);
    font-size: var(--text-variant-100-r-superscript-font-size);
  }
  .Text-variant--50 {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-50-font-size);
    --font-weight: var(--text-variant-50-font-weight);
    --letter-spacing: var(--text-variant-50-letter-spacing);
    --line-height: var(--text-variant-50-line-height);
    --max-width: var(--text-variant-50-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Text-variant--50 :global(sup) {
    font-variant-numeric: tabular-nums;
    vertical-align: super;
    top: 0;
    font-weight: var(--text-variant-50-superscript-font-weight);
    font-size: var(--text-variant-50-superscript-font-size);
  }
  .Text-variant--50-r {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-50-r-font-size);
    --font-weight: var(--text-variant-50-r-font-weight);
    --letter-spacing: var(--text-variant-50-r-letter-spacing);
    --line-height: var(--text-variant-50-r-line-height);
    --max-width: var(--text-variant-50-r-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Text-variant--50-r :global(sup) {
    font-variant-numeric: tabular-nums;
    vertical-align: super;
    top: 0;
    font-weight: var(--text-variant-50-r-superscript-font-weight);
    font-size: var(--text-variant-50-r-superscript-font-size);
  }
  .Text {
    margin: var(--space-none);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }
  .balanced {
    text-wrap: balance;
  }
}</style>
